import React from 'react';
import { Header } from '../../components/Header';
import { Hero } from '../../components/Hero';
import { Portfolio } from '../../components/Portfolio';
import { Expertise } from '../../components/Expertise';
import { TeamSection } from '../../components/TeamSection';
import { Contact } from '../../components/Contact';
import { Footer } from '../../components/Footer';
import { PRODUCTS, TEAM } from '../../utils/constants';

export const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-background text-gray-900 font-sans selection:bg-dotnet/20 selection:text-black">
      <Header />

      <main>
        <Hero />
        <Portfolio products={PRODUCTS} />
        <Expertise />
        <TeamSection members={TEAM} />
        <Contact />
      </main>

      <Footer />
    </div>
  );
};

export default HomePage;
